import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PrintService } from 'src/app/services/print.service';

@Component({
  selector: '[app-status-container]',
  templateUrl: './status-container.component.html',
  styleUrls: ['./status-container.component.scss']
})
export class StatusContainerComponent implements OnInit {

  @Input() title: string;
  @Input() url: string;
  @Input() isActive: boolean;
  @Input() disabledReason: string = '';
  @Input() statusRows: StatusRow[];
  @Input() printEnabled: boolean = true;

  @Output() urlEvent = new EventEmitter<string>();

  constructor(
    private printService: PrintService) { }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

  getDisabledReason(): string {
    return !this.isActive ? this.disabledReason : '';
  }

  emitUrl = () => this.urlEvent.emit(this.url);

  print = () => this.printService.print(this.url);

}

export interface StatusRow {
  status: string,
  topText: string,
  bottomText: string,
  actionUser?: string,
  actionTimestamp?: Date
}
